import { Gift, Truck, Sparkles, Flame, Star } from "lucide-react";
import { useSiteSettings } from "../hooks/useSiteSettings";

const DEFAULT_MESSAGES = [
    "🎁 ¡Por compras sobre $20.000 te llevas un PRODUCTO SORPRESA GRATIS!",
    "🚚 Despachamos a todo Chile en 24-48 hrs",
    "🌶️ Auténticos sabores mexicanos · Lucas, Vero, De la Rosa, Tajín",
    "⭐ Acumula 1 punto por cada $100 — ¡canjea descuentos!",
    "🎁 ¡Sobre $20.000 viene un regalito sorpresa en tu pedido!",
];

const ICON_CYCLE = [Gift, Truck, Flame, Sparkles, Star];

export default function PromoMarquee() {
    const { settings } = useSiteSettings();
    const messages = (settings?.marquee_messages && settings.marquee_messages.length > 0)
        ? settings.marquee_messages
        : DEFAULT_MESSAGES;

    // Duplicate the items so the animation loops seamlessly
    const items = [...messages, ...messages];
    return (
        <div
            data-testid="promo-marquee"
            className="bg-cocoa text-cream overflow-hidden border-b border-mexred/20 relative"
        >
            <div className="fiesta-stripes h-1 w-full" />
            <div className="flex whitespace-nowrap py-2 animate-marquee">
                {items.map((text, i) => {
                    const Icon = ICON_CYCLE[i % ICON_CYCLE.length];
                    return (
                        <div
                            key={i}
                            className="flex items-center gap-2 px-8 text-sm font-medium shrink-0"
                        >
                            <Icon className="w-4 h-4 text-mexyellow" strokeWidth={2.5} />
                            <span className="text-cream/95">{text}</span>
                            <span className="text-cocoa">•</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
